<template>
  <div class="page-product-review">
    <div class="product-info"
         v-if="product"
         @click="handleProductDetail"
    >
      <div class="product-cover">
        <ym-img class="img"
                :src="product.cover"
                alt="封面图"
        />
      </div>
      <div class="product-title">{{ product.title }}</div>
    </div>
    <div class="line"></div>
    <div class="product-review">
      <div class="review-title">
        <span>{{ reveiwProductType }}评分</span>
        <ym-star @starNum="saveStarNum"
        />
      </div>
      <div class="review-content">
        <ym-field class="review-textarea"
                  type="textarea"
                  :rows="8"
                  v-model="content"
                  placeholder="优质评论将会被优先展示哦~"
                  @focusin.native="handleFocusIn"
                  @focusout.native="handleFocusOut"
        />
      </div>
    </div>
    <div class="submit-btn ym-mw-component-fixed-max"
         :class="{ 'active': isFocusIn }"
         @click="handleSubmit"
    >
      <ym-button size="large"
                 type="primary"
                 :disabled="disabled"
      >提交
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Field, Button } from '@ymba/ym-ui';
  import YmStar from '@/components/YmStar';
  import { getProductReviewData, createProductReview } from '@/services/review';

  export default {
    name: 'PageReviewCreate',
    metaInfo() {
      return {
        title: this.pageTitle,
      };
    },
    components: {
      YmStar,
      'ym-field': Field,
      'ym-button': Button,
    },
    data() {
      return {
        id: 0,
        type: '',
        starNum: 5,
        content: '',
        product: null,
        pageTitle: '',
        isFocusIn: false,
      };
    },
    computed: {
      disabled() {
        return this.content.length === 0 || this.starNum === 0;
      },
      reveiwProductType() {
        const { type } = this;
        return type === 'course' ? '课程' : '项目';
      },
    },
    methods: {
      async fetchData() {
        const { id, type } = this.$route.params;
        const data = await getProductReviewData(type, id);
        this.product = data.product;
        this.pageTitle = data.pageTitle;
        this.id = id;
        this.type = type;
      },
      saveStarNum(num) {
        this.starNum = num;
      },
      async handleSubmit() {
        if (this.starNum === 0) {
          this.$toast('请先进行评分');
          return;
        }
        if (this.content.length === 0) {
          this.$toast('请输入评价内容');
          return;
        }
        await createProductReview(this.type, this.id, this.starNum, this.content);
        setTimeout(() => {
          if (this.type === 'course') {
            const route = { name: 'CourseDetail', params: { id: this.id } };
            this.$router.push(route);
          } else {
            const route = { name: 'ProjectDetail', params: { id: this.id } };
            this.$router.push(route);
          }
        }, 3000);
      },
      handleFocusIn() {
        this.isFocusIn = true;
      },
      handleFocusOut() {
        this.isFocusIn = false;
      },
      handleProductDetail() {
        if (this.type === 'course') {
          const route = { name: 'CourseDetail', params: { id: this.id } };
          this.$router.push(route);
        } else {
          const route = { name: 'ProjectDetail', params: { id: this.id } };
          this.$router.push(route);
        }
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-product-review {
    height: 100%;
    background: @color-white;
  }

  .product-info {
    padding: @size-base;
    background: @color-white;
    display: flex;
    align-items: flex-start;
  }

  .line {
    height: @size-small;
    width: 100%;
    background: @background-color-base;
  }

  .product-cover {
    width: 200px;
    height: 160px;
    border-radius: @border-radius-base;
    margin-right: @size-base;
    .img {
      width: 100%;
      height: 100%;
      border-radius: @border-radius-base;
    }
  }

  .product-title {
    width: 460px;
    font-size: @font-size-medium;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    line-height: 1.4;
  }

  .product-review {
    padding: 0 @size-base @size-base;
    background: @color-white;
  }

  .review-title {
    display: flex;
    align-items: center;
    padding: @size-base;
    margin-bottom: @size-base;
    box-sizing: border-box;
    border-bottom: @border-base;
    span {
      margin-right: @size-small;
    }
  }

  .review-content {
    height: 400px;
    .ym-field {
      height: 100%;
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 0;
    padding: @size-base;

    &.active {
      position: relative;
      margin-top: 100px;
    }
  }

</style>
